export const SUPPORTED_LANGUAGES = [
  'javascript',
  'js',
  'python',
  'java',
  'typescript',
  'ts',
  'c++',
  'c#',
  'php',
  'go',
  'ruby',
  'swift',
  'kotlin',
  'rust',
  'scala',
  'r',
  'dart',
  'c',
  'sql',
  'shell',
  'bash',
  'html',
  'css',
  'scss',
  'less',
  'json',
  'yaml',
  'markdown',
  'powershell',
  'lua',
  'perl',
  'matlab',
  'groovy',
  'objective-c',
  'haskell',
  'elixir',
  'erlang',
  'ocaml',
  'prolog',
  'crystal',
];
